var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "100%" } }, [
    _vm.files.length > 1
      ? _c(
          "div",
          { staticStyle: { width: "11%", float: "right", height: "30px" } },
          [
            _c(
              "v-tooltip",
              {
                attrs: { left: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "ma-0",
                                  attrs: {
                                    icon: "",
                                    text: "",
                                    color: "accent",
                                    "x-small": "",
                                    outlined: ""
                                  },
                                  on: { click: _vm.trashFiles }
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c("v-icon", [_vm._v("delete")])],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4107781948
                )
              },
              [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.$tc("DeleteAll")))])]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { "min-height": "77px", width: "100%" } },
      [
        _vm.label ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
        _vm._v(" "),
        _vm.files.length === 0
          ? _c(
              "div",
              {
                staticClass: "file-input-container",
                class: { disabled: _vm.disabled }
              },
              [
                _c("input", {
                  ref: "file",
                  staticClass: "file-input",
                  attrs: {
                    type: "file",
                    accept: _vm.acceptedFileTypes,
                    disabled: _vm.disabled,
                    multiple: _vm.multipleFiles
                  },
                  on: { change: _vm.onFileChange }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "file-input-content flex-horizontal" },
                  [
                    _c("v-icon", { staticClass: "custom-icon" }, [
                      _vm._v("mdi-cloud-upload")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "drop-file-message" }, [
                      _vm._v(_vm._s(_vm.$t("DropFile")))
                    ])
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.files.length === 0 && _vm.fileTypesAsString !== ""
          ? _c("div", { attrs: { id: "file-valid-type" } }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("FileTypeMustBe") + _vm.fileTypesAsString + "."
                  ) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.files, function(file, index) {
          return _vm.files.length !== 0
            ? _c("div", { key: file.name, staticStyle: { width: "100%" } }, [
                _c(
                  "div",
                  { staticClass: "file-input-container file-content" },
                  [
                    _c("span", [_vm._v(_vm._s(file.name))]),
                    _vm._v(" "),
                    _c("TrashSVG", {
                      attrs: { id: "trash-icon" },
                      on: {
                        click: function($event) {
                          return _vm.trashFile(index)
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b714159", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b714159","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Molecules/DropFileArea.vue
// module id = null
// module chunks = 